module.exports = __webpack_public_path__ + "img/logoSACTransparente.d45c9d89.png";